.backdrop {
  bottom: 0;
  left: 0;
  overflow: hidden;
  position: fixed;
  right: 0;
  top: 0;
  z-index: 100;
}

.backdrop::after {
  background-color: var(--color-uva-black);
  content: "";
  inset: 0;
  opacity: 0.5;
  pointer-events: none; /* Allow clicks to pass through ::after element */
}

/*
    Only flex the content when the backdrop is actually showing. The min-height
    and min-width here, correspond to the values in overlay.module.css
  */
@media (min-width: 28rem) and (min-height: 28rem) {
  .backdrop {
    align-items: center;
    display: flex;
    justify-content: center;
  }

  .backdrop::after {
    position: absolute;
  }

  .backdrop > * {
    position: relative;
    z-index: 1;
  }
}
